import * as React from 'react';
import classNames from 'classnames';
import { IconType as  IconTypeProps} from 'react-icons/lib';

import styles from './IconButton.module.scss';
import {Loading} from "@Components/Loading/Loading";

type IconButtonProps = {
    title?: string;
    text?: string;
    className?: string;
    disabled?: boolean;
    IconType: IconTypeProps;
    onClick?: () => void;
    isLoading?: boolean;
};

export const IconButton: React.FC<IconButtonProps> = ({ title, text,  className, disabled, IconType, onClick, isLoading }) => {
    const handleClick = () => {
        if (disabled) return;

        onClick?.();
    }

    return (
        <button
            title={title}
            disabled={disabled}
            className={classNames(styles.wrapper, disabled && styles.disabled, className)}
            onClick={handleClick}
        >
            <IconType />
            { text && <div>{text}</div> }
            {isLoading && <Loading className={styles.loading} fillContainer isSmall/>}
        </button>
    );
};
